import { Statistic } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { numberMask } from "../../../../../../../services/helpersMethodsService";
import useLotDetailsSupplementSupplyContext from "../../../../../../../hooks/useLotDetailsSupplementSupplyContext";

// import { Container } from './styles';

function CardTotalAnimalCostSupplementSupplyDashboard() {
  const { totalSupplyCostPerAnimal } = useLotDetailsSupplementSupplyContext();
  const { translation } = useSelector((state) => state.app);
  return (
    <Statistic
      title={
        translation.lot.production.details.supplementSupply.dashboards
          .totalAnimalCost
      }
      value={numberMask(totalSupplyCostPerAnimal, true)}
      precision={2}
      suffix={
        translation.lot.production.details.supplementSupply.dashboards.suffixCab
      }
    />
  );
}

export default CardTotalAnimalCostSupplementSupplyDashboard;
